// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--Lmg27","text":"_93444fe79c--text--wJ6Hw"};